module.exports = __webpack_public_path__ + "img/mgh-gotanda@2x.a7968b9a.jpg";